import tokens, { type ComplexToken } from '~/public/img/tokens';
import { tokenMetaData } from '~/utils';
import type { Tokens } from '~/utils/constants';

const loadedTokensImages = reactive<Record<'mainnet' | 'testnet' | 'demo', ComplexToken | null>>({
  mainnet: null,
  testnet: null,
  demo: null
});

const preloadComplexTokensImages = async () => {
  const config = useRuntimeConfig();
  const { complexTokensMainnet, complexTokensTestnet, complexTokensDemo } = await import('~/public/img/tokens');

  if (config?.public.env === 'prod') {
    loadedTokensImages.mainnet = complexTokensMainnet;
  } else if (config?.public.env === 'demo') {
    loadedTokensImages.demo = complexTokensDemo;
  } else {
    loadedTokensImages.testnet = complexTokensTestnet;
  }
};

const getIcon = (recipeId: number, tokenAddress: string, isMetadataPriority?: boolean): string => {
  const { blockchain } = useEnvs();
  const config = useRuntimeConfig();
  const tokensImages =
    config?.public.env === 'prod'
      ? loadedTokensImages.mainnet
      : config?.public.env === 'demo'
        ? loadedTokensImages.demo
        : loadedTokensImages.testnet;

  if (!tokensImages) {
    throw new Error('Tokens images not loaded yet.');
  }

  if (recipeId in tokensImages && !isMetadataPriority) {
    return tokensImages[recipeId].toString();
  } else {
    const tokenData = tokenMetaData(blockchain.contracts, tokenAddress);

    return (
      tokens?.[tokenData?.name?.contract as Tokens] || (tokens?.[tokenData?.name?.contract as Tokens] as any)?.common
    )?.toString();
  }
};

export { preloadComplexTokensImages, getIcon };
